import { Injectable } from '@angular/core';
import { syntaxTree } from "@codemirror/language";
import { from, Subject } from 'rxjs';
import { SharedService } from '../services/shared.service';
import { TimeZoneService } from '../services/time-zone.service';

@Injectable({
  providedIn: 'root'
})
export class QueryTokensProviderService {

  constructor(
    private sharedService:SharedService,
    private timezoneservice:TimeZoneService
  ) { }

  // tokens_type_map = {
  //   StringFields: { cat: "field", type: "text", alias: "" },
  //   NumericFields: { cat: "field", type: "number", alias: "" },
  //   TimestampFields: { cat: "field", type: "text", alias: "" },
  //   StringValue: { cat: "value", type: "text" },
  //   NumericValue: { cat: "value", type: "number" },
  //   GenericOperator: { cat: "operator", type: "" },
  //   LogicalOperator: { cat: "termoperator", type: "" },
  //   NumericOperator: { cat: "operator", type: "" },
  //   InOperator: { cat: "operator", type: "" },
  //   LogicalNegate: { cat: "notoperator", type: "" },
  //   ContainsOperator: { cat: "operator", type: "" },
  //   StartswithOperator: { cat: "operator", type: "" },
  //   EndswithOperator: { cat: "operator", type: "" },
  //   WildcardStringValue: { cat: "value", type: "text" },
  //   WildcardNumericValue: { cat: "value", type: "number" },
  //   openparam: { cat: "openparam", type: "" },
  //   closeparam: { cat: "closeparam", type: "" },
  //   Alias: { cat: "tablecolumn", type:"number" },
  //   SortOperator: { cat: "function" },
  //   IpFields: { cat: "field", type: "inet", alias: "" },
  //   IpAddress: { cat: "value", type: "inet" },
  //   WildCardIpValue: { cat: "value", type: "inet" },
  //   StringListValue: { cat: "list", type: "text"},
  //   NumericListValue: { cat: "list", type: "number"},
  //   IPListValue: { cat: "list", type: "inet"},
  //   WildCardStringListValue: { cat: "list", type: "text"},
  //   WildCardNumericListValue: { cat: "list", type: "number"},
  //   WildCardIPListValue: { cat: "list", type: "inet"},
  //   StringFunctionType1: { cat:"function", subcat:"StringFunctionType1", type: "text", alias: ""},
  //   StringFunctionType2: { cat:"function", subcat:"StringFunctionType2", type: "number", alias: ""},
  //   StringFunctionType3: { cat:"function", subcat:"StringFunctionType3", type: "boolean", alias: ""},
  //   StringFunctionType4: { cat:"function", subcat:"StringFunctionType4", type: "text", alias: ""},
  //   StringFunctionType5: { cat:"function", subcat:"StringFunctionType5", type: "text", alias: ""},
  //   StringFunctionType6: { cat:"function", subcat:"StringFunctionType6", type: "text", alias: ""},
  //   NumberFunctionType1: { cat:"function", subcat:"NumberFunctionType1", type: "number", alias: ""},
  //   NumberFunctionType2: { cat:"function", subcat:"NumberFunctionType2", type: "number", alias: ""},
  //   NumberFunctionType3: { cat:"function", subcat:"NumberFunctionType3", type: "number", alias: ""},
  //   TimestampFunctionType1: { cat:"function", subcat:"TimestampFunctionType1", type: "text", alias: ""},
  //   TimestampFunctionType2: { cat:"function", subcat:"TimestampFunctionType2", type: "text", alias: ""},
  //   CommonFunctionType1: { cat:"function", subcat:"CommonFunctionType1", type: "number", alias: ""},
  //   CommonFunctionType2: { cat:"function", subcat:"CommonFunctionType2", type: "text", alias: ""},
  //   ListFunctionType1: {cat:"ListFunction", type: "text"},
  //   ListFunctionType2: {cat:"ListFunction", type: "number"},
  //   ListFunctionType3: {cat:"ListFunction", type: "inet"},
  //   HashTags: {cat:"hashtag", type:""},
  //   AggFunctionType1: { cat: "function",  subcat:"AggFunctionType1", field: "",type: "text", alias: ""},
  //   AggFunctionType2: { cat: "function", subcat:"AggFunctionType2", field: "",type: "number", alias: ""},
  //   ArithmaticExpression: { cat: "expr", type:"number", alias:""},
  //   Fetchall: {}
  // }

  // token_based_parse = {
  //   StringValue:["StringValue"],
  //   WildCard:["WildcardStringValue","WildcardNumericValue","WildCardIpValue","WildCardStringListValue","WildCardNumericListValue","WildCardIPListValue"],
  //   LogicalOperators:["LogicalOperator","LogicalNegate","InOperator","ContainsOperator","StartswithOperator","EndswithOperator"],
  //   Functions:["StringFunctionType1","StringFunctionType2","StringFunctionType3","StringFunctionType4",
  //             "StringFunctionType5","StringFunctionType6","NumberFunctionType1","NumberFunctionType2",
  //             "NumberFunctionType3","TimestampFunctionType1","TimestampFunctionType2","CommonFunctionType1","CommonFunctionType2",
  //             "ListFunctionType1","ListFunctionType2","ListFunctionType3","AggFunctionType1","AggFunctionType2"],
  //   Expression:["ArithmaticExpression"],
  //   Commands:["SearchCommand","CalculateCommand","ByCommand","WhereCommand","FetchCommand","SortCommand","LimitCommand"],
  //   Fields:["StringFields","NumericFields","IpFields","TimestampFields"]
  // }

  convertToArray(str) {
    // Remove the surrounding parentheses
    str = str.slice(1, -1);
    // Split the string by commas and trim any extra whitespace or quotes
    let result = str.split(',').map(item => item.trim().replace(/^"|"$/g, '').replace(/""/g, '"').replace(/^'|'$/g, '').replace(/\\"/g, '"'));

    return result;
  }

  convertToArrayImport(str) {
    // Remove the surrounding parentheses
    if(str.includes('[')){

     
        str = str.slice(1, -1);
        if(str.includes(',')){

        }
        else{
          return [str.trim()]
        }
    }else{
      return [str.trim()]
    }
   
    
    // Split the string by commas and trim any extra whitespace or quotes
    let list = str.split(',').map(item => item.trim().replace(/^"|"$/g, '').replace(/""/g, '"').replace(/^'|'$/g, '').replace(/\\"/g, '"'));
    let result=[]
    // console.log({list})
    // console.log(this.sharedService.partitionsMapObj)
    list.forEach(key=>{
      result.push(this.sharedService.partitionsMapObj[key.trim()])
    })
    // console.log({result})
    return result;
  }

  // reBuildArithmeticExpr(editor,cursor){
  //   const expr_str = editor.state.sliceDoc(cursor.from, cursor.to);
  //   // console.log("================ArithmaticExpression===string================",expr_str)
  //   let expr_rebuild = "";
  //   let expr_cursor = cursor.node.firstChild.cursor();
  //   // console.log("=============expr_cursor=======================",expr_cursor)
  //   do {
  //     if(expr_cursor.name == "NumericFields") {
  //       expr_rebuild += `"${editor.state.sliceDoc(expr_cursor.from, expr_cursor.to)}"`
  //     } else {
  //       expr_rebuild += `${editor.state.sliceDoc(expr_cursor.from, expr_cursor.to)}`
  //     }
  //   } while(expr_cursor.nextSibling())

  //   return {expr_str, expr_rebuild}
  // }
  reBuildArithmeticExpr(editor, cursor, uniqueFields) {
    const expr_str = editor.state.sliceDoc(cursor.from, cursor.to);
    // console.log("================ArithmaticExpression===string================",expr_str)
    let expr_rebuild = "";
    let exp_params = [];
    let expr_cursor = cursor.node.firstChild.cursor();
    // console.log("=============expr_cursor=======================",expr_cursor)
    do {
      if (expr_cursor.name == "NumericFields") {
        expr_rebuild += `"${editor.state.sliceDoc(expr_cursor.from, expr_cursor.to)}"`
        uniqueFields.add(editor.state.sliceDoc(expr_cursor.from, expr_cursor.to))
      } else {
        expr_rebuild += `${editor.state.sliceDoc(expr_cursor.from, expr_cursor.to)}`
      }
      exp_params.push(editor.state.sliceDoc(expr_cursor.from, expr_cursor.to))
    } while (expr_cursor.nextSibling())

    return { expr_str, expr_rebuild, exp_params }
  }

  getAliasName(editor, cursor, default_str) {
    let alias_name = "";
    if (cursor.node.nextSibling?.name == "As") {
      cursor.nextSibling()
      cursor.nextSibling()
      // alias_name = editor.state.sliceDoc(cursor.from, cursor.to).replace(/^"|"$/g, '');
      alias_name = editor.state.sliceDoc(cursor.from, cursor.to)
    } else {
      alias_name = default_str
    }
    // alias_name = alias_name.replace(/"/g, "'");
    alias_name = alias_name.replace(/(?!^)"(?!$)/g, "'");
    return alias_name;
  }

  findPlatformAtFrom(statementobj,engineQuery, mode,lastindex) {
    let fromPlatform = "";
    if (statementobj?.FromCommand) {
      if(statementobj.FromCommand[0]["cat"] == "tablecolumn"){
        fromPlatform = this.platform_alias_map[statementobj.FromCommand[0]["image"]]
      } else {
        fromPlatform = statementobj.FromCommand[0]["image"]
      }
      
    }
    return fromPlatform;
  }

  constructFieldsWithVariable(engineQuery){
    let fetchallTokens = [];
    let unique_variables = new Set();;
    engineQuery.JoinCommand.forEach(joinobj => {
      if(joinobj["cat"] == "variable_name") {
        unique_variables.add(joinobj["image"])
      }
    });
    const unique_variables_list = [...unique_variables]
    unique_variables_list.forEach((variable,ind)=>{
      // engineQuery["LetCommand"][ind]["Statement"][0]["FetchCommand"].forEach(fetchobj => {
      //   fetchobj["variable_name"] = variable
      //   fetallTokens.push(fetchobj)
      engineQuery.LetCommand.forEach((letobj) => {  
          if(letobj["VariableAssignment"][0]["image"] == variable) {
            letobj["Statement"][0]["FetchCommand"].forEach(fetchobj => {
              let newfetchobj = {}
              let newAlias =fetchobj["alias"].replace(/"/g, '');
              if(["function","expr"].includes(fetchobj["cat"]) ){
                
                newfetchobj = {"cat":"tablecolumn","alias":variable+"_"+newAlias,"image":fetchobj["alias"],"type":fetchobj["type"],"variable_name":variable}
              } else {
                newfetchobj = {...fetchobj,"alias":variable+"_"+newAlias,"variable_name":variable,"image":fetchobj["alias"]}
              }
              fetchallTokens.push(newfetchobj)
            });
          }
        });
      });
    
    return fetchallTokens
  }

  buildAllFields(statementobj,engineQuery,mode,commandList,lastindex) {
//console.log({mode})
    const calc_by_tokens = [].concat(statementobj?.ByCommand ?? [], statementobj?.CalculateCommand ?? []);
    let fetallTokens = [];
    let fromPlatform:any
    if (engineQuery?.JoinCommand) {
      fetallTokens = this.constructFieldsWithVariable(engineQuery)
      return fetallTokens
    } else {
      fromPlatform = mode == "search" || mode == "rule"?this.findPlatformAtFrom(statementobj,engineQuery, mode,lastindex):this.sharedService._alertName.getValue();
//console.log({fromPlatform})
      if (calc_by_tokens.length) {
        calc_by_tokens.forEach(token => {
          if (token["cat"] == "field") {
            fetallTokens.push(token)
          } else if (token["cat"] == "function" || token["cat"] == "expr") {
            let token_obj = { ...this.sharedService.tokens_map_obj['tokens_type_map']["Alias"], "image": token["alias"], "alias": token["alias"], "type": token["type"], "variable_name":"" }
            fetallTokens.push(token_obj)
          }
        })

      } else {
        if (mode == 'rule') {
//console.log("<----=|Rule|=---->")
          // console.log("Platform plugIns in shared =---->",this.sharedService.platform_plugins)
          fromPlatform.forEach(plat=>{
            this.sharedService.platform_plugins[plat]["platform_fields"].forEach(field_obj => {
              if (field_obj.is_entity) {
                if(fetallTokens.some(item => item.image === field_obj.value)){
                  // console.log("EXISTS")
                }else{
                  // console.log("NOT EXISTS")
                  fetallTokens.push({ "image": field_obj.value, "alias": field_obj.value, "type": field_obj.display_type, "cat": "field","variable_name":"" })
                }
                // fetallTokens.push({ "image": field_obj.value, "alias": field_obj.value, "type": field_obj.display_type, "cat": "field","variable_name":"" })
              }
            })
          })
          
        } else if (mode == 'search') {
//console.log("<----=|Search|=---->")
          // console.log("Search",this.queryEditorService.platform_fields)
          // this.queryEditorService.platform_fields.forEach((field) => {
          
          fromPlatform.forEach(plat=>{
//console.log({plat})
            this.sharedService.platform_plugins[plat]["platform_fields"].forEach(field => {
              if(fetallTokens.some(item => item.image === field.value)){
              }else{
                fetallTokens.push({ "image": field.value, "alias": field.value, "type": field.display_type, "cat": "field","variable_name":"" })
              }
            })
          })
        } else {
          // console.log("Alert",this.queryEditorService.tokens_map_obj['token_category']["Fields"])
          // console.log(this.sharedService.alert_rule_plugins)
          // console.log({fromPlatform})
//console.log("<----=|Alert|=---->")
          this.sharedService.tokens_map_obj['token_category']["Fields"].forEach((field_type => {
            let token_cat_obj = this.sharedService.tokens_map_obj['tokens_type_map'][field_type]
            this.sharedService.alert_rule_plugins[fromPlatform]["external_tokens"][field_type].forEach(field => {
              let token_obj = { ...token_cat_obj, "image": field, "alias": field,"variable_name":"" }
              fetallTokens.push(token_obj)
            })

          }))
        }

      }
      // console.log("<=============fetallTokens=============>",fetallTokens)
      return fetallTokens
    }
    
  }

  findAliasType(engineQuery, alias_name) {
    const calc_by_fetch_tokens = [].concat(engineQuery?.CalculateCommand ?? [], engineQuery?.ByCommand ?? [], engineQuery?.FetchCommand ?? []);
    let alias_type = "number";
    if (calc_by_fetch_tokens.length) {
      for (const token of calc_by_fetch_tokens) {
        if (token["alias"] == alias_name) {
          // console.log("<============findAliasType==============>",token["type"]);
          alias_type = token["type"];
          break;
        }
      }
    }
    return alias_type;
  }

  makeNewSearchtokens(editor, commandList, cmdindexlist, position, uniqueFields, mode, statementobj,engineQuery) {
    // let tree = syntaxTree(editor.state).cursor().node.getChild(commandName);
    let lastindex = 0
    let tree = syntaxTree(editor.state).cursor().node;
    commandList.forEach((cmd, ind) => {
      tree = tree.getChildren(cmd)[cmdindexlist[ind]]
      lastindex = cmdindexlist[ind]
    })
    let cursor = tree.cursor();
    // Move cursor to the desired position
    cursor.moveTo(position[0], position[1]);
    let token_obj_container = [];
    if (cursor.firstChild()) {
      
      do {
        let token_obj = {};
        // console.log("cursor name------->",cursor.name)
        if (this.sharedService.tokens_map_obj['tokens_type_map'].hasOwnProperty(cursor.name)) {
          token_obj = { ...token_obj, ...this.sharedService.tokens_map_obj['tokens_type_map'][cursor.name] }
          if (cursor.name == "StringValue") {
            token_obj['image'] = editor.state.sliceDoc(cursor.from, cursor.to).replace(/^"|"$/g, '').replace(/""/g, '"').replace(/\\"/g, '"');
          } else if (this.sharedService.tokens_map_obj['token_category']["WildCard"].includes(cursor.name)) {
            token_obj['image'] = this.convertToArray(editor.state.sliceDoc(cursor.from, cursor.to));
          } else if (this.sharedService.tokens_map_obj['token_category']["LogicalOperators"].includes(cursor.name) || this.sharedService.tokens_map_obj['token_category']["ComparisonOperators"].includes(cursor.name)) {
            token_obj['image'] = editor.state.sliceDoc(cursor.from, cursor.to).toUpperCase();
          } else if (this.sharedService.tokens_map_obj['token_category']["Functions"].includes(cursor.name)) {
            const functionstring = editor.state.sliceDoc(cursor.from, cursor.to);
            const function_type = JSON.stringify(cursor.name)
            let funcName = editor.state.sliceDoc(cursor.node.firstChild.from, cursor.node.firstChild.to);
            let funct_cursor = cursor.node.firstChild.nextSibling.nextSibling.cursor();
            let lastChildPos = cursor.node.lastChild.from;
            let params = [];
            do {
              if (funct_cursor.from >= lastChildPos) {
                break
              }
              if (funct_cursor.name == "ArithmaticExpression") {
                // const {expr_str, expr_rebuild} =  this.reBuildArithmeticExpr(editor,funct_cursor)
                const { expr_str, expr_rebuild, exp_params } = this.reBuildArithmeticExpr(editor, funct_cursor, uniqueFields)

                params.push(expr_rebuild)
              } else if (funct_cursor.name == "Distinct") {
                let param = editor.state.sliceDoc(funct_cursor.from, funct_cursor.to);
                funct_cursor.nextSibling()
                uniqueFields.add(editor.state.sliceDoc(funct_cursor.from, funct_cursor.to))
                param += ` "${editor.state.sliceDoc(funct_cursor.from, funct_cursor.to)}"`;
                params.push(param)
              } else if (funct_cursor.name != "Comma") {
                let param = editor.state.sliceDoc(funct_cursor.from, funct_cursor.to).replace(/^"|"$/g, '').replace(/\\"/g, '"');
                if (this.sharedService.tokens_map_obj['token_category']["Fields"].includes(funct_cursor.name)) {
                  uniqueFields.add(param)
                  param = `"${param}"`
                }
                params.push(param)
              }
            } while (funct_cursor.nextSibling())

            token_obj['image'] = funcName;
            token_obj['params'] = params;
            token_obj = { ...token_obj, ...this.sharedService.tokens_map_obj['tokens_type_map'][function_type] };
            token_obj["alias"] = this.getAliasName(editor, cursor, `"${functionstring}"`)
          } else if (cursor.name == "ArithmaticExpression") {
            // const {expr_str, expr_rebuild} =  this.reBuildArithmeticExpr(editor,cursor)
            const { expr_str, expr_rebuild, exp_params } = this.reBuildArithmeticExpr(editor, cursor, uniqueFields)
            token_obj['image'] = expr_rebuild;
            token_obj["alias"] = this.getAliasName(editor, cursor, `"${expr_str}"`)
            token_obj["params"] = exp_params;
          } else if (cursor.name == "Fetchall" && commandList[commandList.length - 1] == "FetchCommand") {
            token_obj_container = this.buildAllFields(statementobj,engineQuery, mode,commandList,lastindex)
          } 
          else if(this.sharedService.tokens_map_obj['token_category']["Table"].includes(cursor.name.trim())){
            // console.log("Inside Table")

            let alias_str = editor.state.sliceDoc(cursor.from, cursor.to)
            
            // if(cursor.name === "Tables"){
              token_obj['image'] = this.convertToArrayImport(editor.state.sliceDoc(cursor.from, cursor.to));
              token_obj["alias"] = this.getAliasName(editor, cursor, alias_str).replace(/(?!^)"(?!$)/g, "'");
            // }else{
            //   token_obj['image'] = [editor.state.sliceDoc(cursor.from, cursor.to)]
            // }
//console.log(token_obj)
       
          }
          else {
            // console.log("=======@#@#@#============cursor name============@#@#@#=================",cursor.name)
            if (this.sharedService.tokens_map_obj['token_category']["Fields"].includes(cursor.name)) {
              uniqueFields.add(editor.state.sliceDoc(cursor.from, cursor.to).replace(/(?!^)"(?!$)/g, "'"))
              token_obj["variable_name"] = ""
            }
            let alias_str = editor.state.sliceDoc(cursor.from, cursor.to)
            if (commandList[commandList.length - 1] == "FetchCommand") {
              if(cursor.name == "Variable") {
                let variable_name = editor.state.sliceDoc(cursor.from, cursor.to);
                token_obj["variable_name"] = variable_name;
         
                cursor.nextSibling()
                cursor.nextSibling()
                alias_str=variable_name+"_"+editor.state.sliceDoc(cursor.from, cursor.to).replace(/(?!^)"(?!$)/g, "'").replace(/"/g, '')
                token_obj = { ...token_obj, ...this.sharedService.tokens_map_obj['tokens_type_map'][cursor.name] }
              } 
            }


            // let alias_str = editor.state.sliceDoc(cursor.from, cursor.to).replace(/^"|"$/g, '');
            // token_obj['image'] = editor.state.sliceDoc(cursor.from, cursor.to).replace(/^"|"$/g, '');
            
            // token_obj['image'] = editor.state.sliceDoc(cursor.from, cursor.to).replace(/(?!^)"(?!$)/g, "'");
            // token_obj['image'] = commandList[0] == "ImportCommand" ? [editor.state.sliceDoc(cursor.from, cursor.to).replace(/(?!^)"(?!$)/g, "'")] : editor.state.sliceDoc(cursor.from, cursor.to).replace(/(?!^)"(?!$)/g, "'");
            token_obj['image'] = editor.state.sliceDoc(cursor.from, cursor.to).replace(/(?!^)"(?!$)/g, "'");
            token_obj["alias"] = this.getAliasName(editor, cursor, alias_str).replace(/(?!^)"(?!$)/g, "'");
            // console.log(token_obj,commandList)
            if (cursor.name == "Alias") {
              token_obj["type"] = this.findAliasType(statementobj, token_obj["alias"])
            }


            

            // if(["FetchCommand"].includes(commandName)){
            //   token_obj["alias"] = this.getAliasName(editor,cursor,alias_str)
            // }
          }
          if (Object.keys(token_obj).length) {
            token_obj_container.push(token_obj)
          }
        }

          
        // else if (cursor.name == "Tables") {
        //   let tables=[]
        //   cursor.node.getChildren("Table").forEach(element => {
        //     tables.push(editor.state.sliceDoc(element.from, element.to).replace(/(?!^)"(?!$)/g, "'"));

        //   });
        //   token_obj['image'] = tables;

        //   // token_obj["type"] = this.findAliasType(statementobj, token_obj["alias"])
        // }

      } while (cursor.nextSibling());
    }
    return token_obj_container;
  }

  getChildNodeNames(editor, from, to) {
    let tree = syntaxTree(editor.state);
    let cursor = tree.cursor();

    // Move cursor to the desired position
    cursor.moveTo(from, to);
    let childNodeNames = {};
    if (cursor.firstChild()) {
      do {
        if (!childNodeNames.hasOwnProperty(cursor.type.name)) {
          childNodeNames[cursor.type.name] = [];
        }
        let childobj = {}
        childobj[cursor.type.name] = [cursor.from, cursor.to]
        childNodeNames[cursor.type.name].push(childobj);
        
      } while (cursor.nextSibling());
    }

    return childNodeNames;
  }

  processrelativetime(time: any) {
    const currentusertime = this.timezoneservice.getcurrentuserTime();
    if (time[1] == "hours") {
      const start_date = currentusertime.clone().subtract(time[2], 'hour');
      return [start_date.format('YYYY-MM-DD HH:mm:ss'), currentusertime.format('YYYY-MM-DD HH:mm:ss')];
    } else if (time[1] == "today") {
      const start_date = currentusertime.clone();
      return [start_date.set({ 'hour': 0, 'minute': 0, 'second': 0 }).format('YYYY-MM-DD HH:mm:ss'), currentusertime.format('YYYY-MM-DD HH:mm:ss')];
    } else if (time[1] == "yesterday") {
      const start_date = currentusertime.clone().subtract(1, 'days');
      return [start_date.set({ 'hour': 0, 'minute': 0, 'second': 0 }).format('YYYY-MM-DD HH:mm:ss'), start_date.endOf('day').format('YYYY-MM-DD HH:mm:ss')];
    } else if(time[1] == "months") {
      const previousdate = currentusertime.clone().subtract(time[2], 'month');
      return [previousdate.startOf('M').format('YYYY-MM-DD HH:mm:ss'), previousdate.endOf('M').format('YYYY-MM-DD HH:mm:ss')];
    } else {
      const previousdate = currentusertime.clone().subtract(time[2], 'days');
      return [previousdate.set({ 'hour': 0, 'minute': 0, 'second': 0 }).format('YYYY-MM-DD HH:mm:ss'), currentusertime.format('YYYY-MM-DD HH:mm:ss')];
    }
  }

  uniqueFields = new Subject();
  unique$ = this.uniqueFields.asObservable();

  uniqueFields1 = []

  getUniqueFields() {
    return [...this.uniqueFields1]
  }

  platform_alias_map = {}

  findPlatformAliasFromImport(context) {
    this.platform_alias_map = {};
    // let importCommandList = syntaxTree(context.state).cursor().node.getChildren("ImportCommand");
    // importCommandList.forEach((command)=>{
    //   if(command.lastChild.name == "Alias"){
    //     this.platform_alias_map[context.state.sliceDoc(command.lastChild.from, command.lastChild.to)] = this.convertToArrayImport(context.state.sliceDoc(command.firstChild.nextSibling.from,command.firstChild.nextSibling.to) )
    //   }
    // })
    let importCommandList = syntaxTree(context.state).cursor().node.getChildren("ImportCommand");
    importCommandList.forEach((command)=>{
      if(command.lastChild.name == "Alias"){
        let alias_name = context.state.sliceDoc(command.lastChild.from, command.lastChild.to);
        if(command.firstChild.nextSibling.name == "Tables"){
          let tables = command.firstChild.nextSibling.getChildren("Table")
          let part_dispnames = tables.map(table=>context.state.sliceDoc(table.from,table.to))
          let part_valuenames = part_dispnames.map((part:any)=>this.sharedService.partitionsMapObj[part])
          this.platform_alias_map[alias_name] = part_valuenames
        } else if(command.firstChild.nextSibling.name == "Table"){
          let part_disp_name = context.state.sliceDoc(command.firstChild.nextSibling.from,command.firstChild.nextSibling.to)
          let part_valuename = this.sharedService.partitionsMapObj[part_disp_name]
          this.platform_alias_map[alias_name] = [part_valuename]
        }
      }
    })
    // console.log("Platform Alias Map =---->",this.platform_alias_map)
  }


  buildStatementObj(editor, commandList, cmdindexlist, position, uniqueFields, mode, statementobj,engineQuery) {
//console.log({commandList})
    let tree = syntaxTree(editor.state).cursor().node;
    commandList.forEach((cmd, ind) => {
      tree = tree.getChildren(cmd)[cmdindexlist[ind]]
    })
    let cursor = tree.cursor();
    // Move cursor to the desired position
    cursor.moveTo(position[0], position[1]);

    let tokens_list = [];
    // statementobj = {};

    if (cursor.firstChild()) {
      do {
//console.log(cursor.name)
        // if(tree.getChild(cursor.name).firstChild) {
        //   this.makeParentTokens(editor,[...commandList,cursor.name],[cursor.from,cursor.to])
        // } else {
        // console.log("command",commandList)
        if (cursor.name == "Scripts") {
          statementobj = { ...statementobj, ...this.buildStatementObj(editor, [...commandList, cursor.name], [...cmdindexlist, 0], [cursor.from, cursor.to], uniqueFields, mode, statementobj,engineQuery) }
        } else if(cursor.name != "Pipe") {
          tokens_list = this.makeNewSearchtokens(editor, [...commandList, cursor.name], [...cmdindexlist, 0], [cursor.from, cursor.to], uniqueFields, mode, statementobj,engineQuery);
          if(cursor.name == "WhenCommand" && tokens_list.length){
            let time_range = []
            if(tokens_list[0]["cat"] == "relativetimeprefix") {
              let timeunit = tokens_list[1]["image"] == "days" ? tokens_list[1]["image"]-1 >= 0 ? tokens_list[1]["image"]-1:tokens_list[1]["image"]:tokens_list[1]["image"]
              let time_value = [-1,tokens_list[2]["image"],timeunit]
              time_range = this.processrelativetime(time_value)
              time_range = [this.timezoneservice.toUtcTimeZonefromUser(time_range[0]).format('YYYY-MM-DD HH:mm:ss'),this.timezoneservice.toUtcTimeZonefromUser(time_range[1]).format('YYYY-MM-DD HH:mm:ss')]
            } 
            else if(tokens_list[0]["cat"] == "openparam" && tokens_list[1]["cat"] == "date") {
              time_range = [this.timezoneservice.toUtcTimeZonefromUser(tokens_list[1]["image"],"DD-MM-YYYY HH:mm:ss").format('YYYY-MM-DD HH:mm:ss'),this.timezoneservice.toUtcTimeZonefromUser(tokens_list[2]["image"],"DD-MM-YYYY HH:mm:ss").format('YYYY-MM-DD HH:mm:ss')]
            }
            tokens_list = [{"cat":"time_range","image":time_range}]
          }
          statementobj[cursor.name] = tokens_list
        }

        // cursor.moveTo(cursor.to,-1)
        // }
      } while (cursor.nextSibling())

    }
    return statementobj;
  }

  buildLetObj(editor, commandList, cmdindexlist, position, uniqueFields, mode, statementobj,engineQuery) {
    let tree = syntaxTree(editor.state).cursor().node;
    commandList.forEach((cmd, ind) => {
      tree = tree.getChildren(cmd)[cmdindexlist[ind]]
    })
    let cursor = tree.cursor();
    // Move cursor to the desired position
    cursor.moveTo(position[0], position[1]);

    let tokens_list = [];
    statementobj = {};
    let letobj = {};

    if (cursor.firstChild()) {
      do {
        if (cursor.name == "Statement") {
          statementobj = this.buildStatementObj(editor, [...commandList, cursor.name], [...cmdindexlist, 0], [cursor.from, cursor.to], uniqueFields, mode, statementobj,engineQuery);
          letobj[cursor.name] = [statementobj]
        }
        else {

          tokens_list = this.makeNewSearchtokens(editor, [...commandList, cursor.name], [...cmdindexlist, 0], [cursor.from, cursor.to], uniqueFields, mode, statementobj,engineQuery);
          // letobj[cursor.name] = tokens_list
          if(tokens_list.length && cursor.name !="Semicolon"){
            letobj[cursor.name] = tokens_list
          }
        }

        // cursor.moveTo(cursor.to,-1)
        // }
      } while (cursor.nextSibling())
    }
    return letobj
  }

  buildJoinObj(editor, commandList, cmdindexlist, position, uniqueFields, mode, statementobj,engineQuery) {
    let tree = syntaxTree(editor.state).cursor().node;
    commandList.forEach((cmd, ind) => {
      tree = tree.getChildren(cmd)[cmdindexlist[ind]]
    })
    let cursor = tree.cursor();
    // Move cursor to the desired position
    cursor.moveTo(position[0], position[1]);

    let tokens_list = [];
    statementobj = {};
    let joinobj = {};

    if (cursor.firstChild()) {
      do {
        tokens_list = this.makeNewSearchtokens(editor, [...commandList, cursor.name], [...cmdindexlist, 0], [cursor.from, cursor.to], uniqueFields, mode, statementobj,engineQuery);
        joinobj[cursor.name] = tokens_list
      } while (cursor.nextSibling())
    }

    return joinobj
  }

  buildCommandObj(editor, command, cmdindex, position, engineQuery, uniqueFields, mode) {
    let commandList = [];
    let tokens_list = [];
    let statementobj = {};
    let letobj = {};

    if (["ImportCommand"].includes(command)) {
      commandList.push(command);
      tokens_list = this.makeNewSearchtokens(editor, commandList, [cmdindex], position, uniqueFields, mode, statementobj,engineQuery);
      engineQuery[command].push(tokens_list);
    } else if (command == "Statement") {
      commandList.push(command);
      statementobj = this.buildStatementObj(editor, commandList, [cmdindex], position, uniqueFields, mode, statementobj,engineQuery)
      engineQuery[command].push(statementobj)
    } else if (command == "LetCommand") {
      commandList.push(command);
      letobj = this.buildLetObj(editor, commandList, [cmdindex], position, uniqueFields, mode, statementobj,engineQuery)
      engineQuery[command].push(letobj)
    } else if (["JoinCommand", "FetchCommand","FilterCommand","SearchCommand","CalculateCommand","WhereCommand","ByCommand","SortCommand","LimitCommand"].includes(command)) {
      commandList.push(command);
      tokens_list = this.makeNewSearchtokens(editor, commandList, [cmdindex], position, uniqueFields, mode, statementobj,engineQuery);
      engineQuery[command] = tokens_list;
    }
    // console.log("###########engine query############",engineQuery)
  }

  parseTokens(editor, mode = 'search') {
    let engineQuery = {};
    let uniqueFields = new Set();
    this.findPlatformAliasFromImport(editor)
    if (editor.state.doc.length) {
      let from = 0;
      let to = editor.state.doc.length;
      const commandObj = this.getChildNodeNames(editor, from, to);
      if (Object.keys(commandObj)) {
        Object.entries(commandObj).forEach(([ptcommand, commandList]: [string, []]) => {
          commandList.forEach((cmdobj, cmdindex) => {
            Object.entries(cmdobj).forEach(([command, position]) => {
//console.log("=================command==parsetokens=======",command)
              if (!engineQuery.hasOwnProperty(command)) {
                engineQuery[command] = []
              }
              this.buildCommandObj(editor, command, cmdindex, position, engineQuery, uniqueFields, mode)
            })
          })
        })

      }
    }
    else {
//console.log("search condition is empty!");
    }
//console.log("uniqueFields=========",[...uniqueFields])
    this.uniqueFields1 = [...uniqueFields]
    // this.uniqueFields.next(uniqueFields)
//console.log("###########engine query############", engineQuery)
    return engineQuery
  }

  getFirstPipePosition(editor) {
    let from = 0;
    let to = editor.state.doc.length;
    let tree = syntaxTree(editor.state);
    let cursor = tree.cursor();
    // Move cursor to the desired position
    cursor.moveTo(from, to);

    let startOffset = -1;
    let endOffset = -1;

    if (cursor.firstChild()) {
      do {
        if (cursor.name == "Pipe") {
          startOffset = cursor.from;
          endOffset = cursor.to;
          return {
            startOffset,
            endOffset
          }
        }
      } while (cursor.next());
    }

    return null;
  }


}
